<template>
  <div>
    <div class="form">
      <div class="item">
        <div class="label">父级菜单:</div>
        <el-select v-model="info.fid" filterable placeholder="请选择父级菜单">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.menu_name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="label">菜单级别:</div>
        <el-select v-model="info.type" filterable placeholder="请选择菜单级别">
          <el-option
            v-for="item in menuClass"
            :key="item.type"
            :label="item.type"
            :value="item.type">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="label">菜单名:</div>
        <el-input v-model="info.menu_name" placeholder="请输入菜单名"></el-input>
      </div>
      <div class="item">
        <div class="label">菜单url:</div>
        <el-input v-model="info.menu_url" placeholder="请输入菜单url"></el-input>
      </div>
      <el-button type="primary" @click="onAddRouterClick">提交</el-button>
    </div>
    <div class="form">
      <div class="item">
        <div class="label">所有菜单:</div>
        <el-select v-model="deleteUuid" filterable placeholder="请选择菜单">
          <el-option
            v-for="item in allMenu"
            :key="item.id"
            :label="item.menu_name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="onDeleteClick">删除</el-button>
    </div>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      width="30%"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
         确定删除该菜单吗？
      </div>
		</common-dialog>
     <div class="form">
      <div class="item">
        <div class="label">所有菜单:</div>
        <el-select v-model="menuId" filterable placeholder="请选择菜单">
          <el-option
            v-for="item in allMenu"
            :key="item.id"
            :label="item.menu_name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="label">菜单名称改为:</div>
        <el-input v-model="menuName" placeholder="请输入内容"></el-input>
      </div>
      <el-button type="primary" @click="onEditClick">修改</el-button>
    </div>
  </div>
</template>
<script>
// import { routerlist, newrouter, deletePermission, editrouter} from '@/api/router-manage';
import CommonDialog from '@/components/CommonDialog';

export default {
  name: 'addrouter',
  data() {
    return {
    	info: {
    		fid: '',
        menu_name: '',
        menu_url: '',
        type: ''
    	},
    	options: [],
    	menuClass: [
        {id: 1, type: '1'},
        {id: 2, type: '2'},
        {id: 3, type: '3'},
      ],
      dialogTitle: '',
      dialogVisible: false,
      deleteUuid: '',
      allMenu: [],
      menuId: '',
      menuName: ''
    }
  },
  components: {
    CommonDialog,
  },
  mounted() {
    this.getRouterList();
  },
  methods: {
    async getRouterList() {
      const { data, status } = await routerlist();
      if (status !== 200) return
      let result = [];
      let allMenu = []
      if (data.one && data.one.length) {
        data.one.forEach( item => {
          result.push(item);
          allMenu.push(item);
          if (item.two && item.two.length) {
            item.two.forEach( inner => {
              result.push(inner)
              allMenu.push(inner)
              if (inner.three && inner.three.length) {
                inner.three.forEach( three => {
                  allMenu.push(three)
                })
              }
            })
          }
        })
      }
      this.options = result;
      this.allMenu = allMenu;
      console.log(data, 'router-list') 
    },
    async onAddRouterClick () {
      const { fid } = this.info;
      fid? '' :  this.info.fid = '0';
      const { data, status } = await newrouter(this.info);
      console.log(data, status, '新增数据')
      if (status !== 200) return
      //新增路由成功后把表单清空并重新获取路由列表
      this.info = {};
      this.getRouterList();
    },
    async onDeleteClick() {
      this.dialogTitle = '提示'
      this.dialogVisible = true
    },
    async dialogConfirmClick() {
      const { status } = await deletePermission(this.deleteUuid);
      if (status === 200 ) {
        this.dialogVisible = false
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.info = {},
      this.deleteUuid = '',
      this.getRouterList()
    },
    async onEditClick() {
      let menu;
      this.allMenu.forEach( item => {
        if (item.id === this.menuId) {
          this,menu = item;
        }

      })
      menu.menu_name = this.menuName;
      const { status } = await editrouter(menu);
      if ( status === 200 ) {
        this.getRouterList()
      }
    }
  }
};
</script>

<style lang="less" scoped>

.form {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
  margin-top: 20px;
  .item {
  	display: flex;
  	align-items: center;
  	margin-bottom: 20px;
    .label {
    	margin-right: 10px;
    	width: 80px;
    }
  }
}
</style>
